import React from 'react';

function Spinner() {
  return (
    <div className='site-loader'>
      <div className='inner-wrapper'>
        <svg version='1.1' id='Layer_1' x='0px' y='0px' viewBox='0 0 271 219.9'>
          <circle className='second1' cx='246.1' cy='194.5' r='22.8' />
          <path
            className='first1'
            d='M97.6,172.5v44.8h-9.9c-11.7,0-22.7-2.2-33.1-6.7c-10.3-4.5-19.3-10.5-27-18.2s-13.7-16.7-18.1-27C5.1,155,3,144,3,132.3
        V2.8h44.8v129.5c0,5.5,1.1,10.8,3.2,15.7c2.1,4.9,5,9.2,8.6,12.8c3.6,3.6,7.8,6.5,12.6,8.6c4.8,2.1,10,3.2,15.5,3.2H97.6z'
          />
          <path
            className='third1'
            style={{ fill: '#8DC247' }}
            d='M198.8,172.5v44.8h-9.9c-11.7,0-22.7-2.2-33.1-6.7c-10.3-4.5-19.3-10.5-27-18.2s-13.7-16.7-18.1-27
        c-4.4-10.3-6.6-21.4-6.6-33.1V50.8h44.8v81.4c0,5.5,1.1,10.8,3.2,15.7c2.1,4.9,5,9.2,8.6,12.8c3.6,3.6,7.8,6.5,12.6,8.6
        c4.8,2.1,10,3.2,15.5,3.2H198.8z'
          />
        </svg>
      </div>
    </div>
  );
}

export default Spinner;
